export enum GameType {
  Summer = 'summer-sports',
  Winter = 'winter-sports',
}
